import type { FC } from 'react';

import { DynamicImage } from '@wwe-portal/ui/components/dynamic-image';
import { cn } from '@wwe-portal/ui/lib/lib';

import type { OfferItem as OfferItemType } from '../type';

import { StarRarity } from './star-rarity';

export const OfferItems: FC<{
  maxItem: number;
  items?: OfferItemType[];
  itemWidth: string;
  isHiddenQuantity?: boolean;
  totalItems?: number;
}> = ({ items, maxItem, itemWidth, totalItems, isHiddenQuantity = false }) => {
  if (items == null || items.length === 0) return null;
  const renderedItems = items.slice(0, maxItem);
  const itemLen = items.length;

  return (
    <div className="absolute inset-0 flex items-center justify-center gap-2 stroke-2 font-semibold text-white">
      {renderedItems.map((item) => {
        const isMore = item.text?.includes('MORE') && totalItems != null;

        return (
          <div
            className="flex h-full shrink-0 grow-0 flex-col items-center justify-end gap-1.5"
            data-id={item.itemId}
            key={item.itemId}
            style={{
              width: itemWidth,
            }}
          >
            <div className="relative h-0 w-full shrink-0 grow">
              <DynamicImage
                alt={item.itemId}
                className="h-full w-full object-contain object-bottom"
                defaultUrl={item.defaultImageUrl}
                dynamicUrl={item.dynamicImageUrl}
                resizedWidth={64}
              />
              <StarRarity item={item} />
            </div>

            <div
              className={cn(
                'h-[calc(1200%/58)] shrink-0 grow-0 text-xs capitalize leading-none',
                {
                  hidden: isHiddenQuantity,
                  'whitespace-nowrap break-keep lowercase': isMore,
                }
              )}
            >
              {isMore
                ? `+${totalItems - itemLen} more`
                : item.text ||
                  (item.quantity && <span>{item.text ?? item.quantity}</span>)}
            </div>
          </div>
        );
      })}
    </div>
  );
};
